<template>
  <div>
    <breadcrumbs home="Workflow">
      <template v-slot:right v-if="permission('config.write')">
        <v-menu bottom max-width="300" :open-on-click="false" :close-on-click="false" :close-on-content-click="false" content-class="tour-arrow tour-arrow-right purple white--text pt-6 px-4" transition="slide-y-transition" :value="hint">
          <template v-slot:activator="{on:tour}">
            <v-menu offset-y :close-on-content-click="false" nudge-bottom="5">
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on" class="mr-3">mdi-tune-variant</v-icon>
              </template>
              <v-card flat class="pa-4 pt-1">
                <v-switch v-if="permission('buying')" v-model="settings.purchasing" dense hide-details @change="changeView">
                  <template v-slot:label><div class="text-caption">Purchasing</div></template>
                </v-switch>
                <v-switch v-if="permission('selling')" v-model="settings.sales" dense @change="changeView">
                  <template v-slot:label><div class="text-caption">Sales</div></template>
                </v-switch>
                <v-divider/>
                <v-switch v-if="permission('production')" v-model="settings.mashing" dense hide-details @change="{settings.distilling = settings.mashing || settings.mashing;changeView()}">
                  <template v-slot:label><div class="text-caption">Mashing</div></template>
                </v-switch>
                <v-switch v-if="permission('production')" v-model="settings.distilling" dense hide-details @change="changeView" :disabled="settings.mashing">
                  <template v-slot:label><div class="text-caption">Distilling</div></template>
                </v-switch>
                <v-switch v-if="permission('production')" v-model="settings.blending" dense @change="changeView">
                  <template v-slot:label><div class="text-caption">Blending</div></template>
                </v-switch>
                <v-divider/>
                <v-switch v-if="permission('inventory')" v-model="settings.wine" dense hide-details @change="changeView">
                  <template v-slot:label><div class="text-caption">Wine</div></template>
                </v-switch>
                <v-switch v-if="permission('inventory')" v-model="settings.casks" dense hide-details @change="changeView">
                  <template v-slot:label><div class="text-caption">Casks</div></template>
                </v-switch>
                <v-switch v-if="permission('inventory')" v-model="settings.bulkContainers" dense hide-details @change="changeView">
                  <template v-slot:label><div class="text-caption">Bulk containers</div></template>
                </v-switch>
              </v-card>
            </v-menu>
          </template>
          You can customize what is shown on the workflow view.
          <div class="mt-1">
            <v-btn plain class="white--text mt-4 float-right" @click.stop="done()">Got it</v-btn>
          </div>
        </v-menu>
      </template>
    </breadcrumbs>

    <div style="height:calc(100vh - 105px)" class="text-center overflow-y pt-4">

      <div style="position:relative;width:950px;display:inline-block" :style="'height:'+(settings.purchasing||settings.sales?'720px':'520px')">

        <!-- Purchasing & Sales -->
        <div style="position:absolute;top:0px;" v-show="settings.purchasing || settings.sales">
          <template v-if="this.permission('buying') && settings.purchasing">

            <!-- PO -->
            <div style="position:absolute;top:0px;left:0px">
              <v-badge color="red" :content="purchaseOrdersRequiringApproval" :value="purchaseOrdersRequiringApproval>0" overlap offset-x="15" offset-y="15">
                <v-btn class="rounded-rectangle" :to="{name:'PurchasingPurchaseOrders'}">Purchase Orders</v-btn>
              </v-badge>
            </div>
            <div class="horizontal-line" style="top:25px; left:150px; width:50px"/>
            <div class="arrow-right" style="top:19px; left:194px"/>

            <!-- Inventory receipts -->
            <div style="position:absolute;top:0px;left:200px">
              <v-badge color="red" :content="inventoryReceiptsDraft" :value="inventoryReceiptsDraft>0" overlap offset-x="15" offset-y="15">
                <v-btn class="rounded-rectangle text-body-2" :to="{name:'PurchasingInventoryReceipts'}">Inventory Receipts</v-btn>
              </v-badge>
            </div>
            <div class="vertical-line" style="top:50px; left:275px; height:125px"/>
            <div class="arrow-down" style="top:168px; left:269.5px"/>
          </template>

          <template v-if="this.permission('selling') && settings.sales">
            <!-- Sales orders -->
            <div style="position:absolute;top:50px;left:800px">
              <v-badge color="error" :content="salesOrdersOpen" :value="salesOrdersOpen>0" overlap offset-x="15" offset-y="15">
                <v-btn class="rounded-rectangle" :to="{name:'SalesSalesOrders'}">Sales Orders</v-btn>
              </v-badge>
            </div>
            <div class="horizontal-line" style="top:75px; left:775px; width:25px"/>
            <div class="horizontal-line" style="top:25px; left:750px; width:25px"/>
            <div class="arrow-left" style="top:20px; left:750px"/>
            <div class="horizontal-line" style="top:125px; left:750px; width:25px"/>
            <div class="arrow-left" style="top:120px; left:750px"/>
            <div class="vertical-line" style="top:25px; left:775px; height:100px"/>

            <!-- Estimates -->
            <div style="position:absolute;top:150px;left:800px">
              <v-badge color="error" :content="salesOrdersOpen" :value="estimatesPending>0" overlap offset-x="15" offset-y="15">
                <v-btn class="rounded-rectangle" :to="{name:'SalesEstimates'}">Estimates</v-btn>
              </v-badge>
            </div>
            <div class="arrow-up" style="top:101px; left:869.5px"/>
            <div class="vertical-line" style="top:100px; left:875px; height:50px"/>

            <!-- Invoices -->
            <div style="position:absolute;top:0px;left:600px">
              <v-badge color="red" :content="invoicesDraft" :value="invoicesDraft>0" overlap offset-x="15" offset-y="15">
                <v-btn class="rounded-rectangle" :to="{name:'SalesInvoices'}">Invoices</v-btn>
              </v-badge>
            </div>

            <!-- Shipments -->
            <div style="position:absolute;top:100px;left:600px">
              <v-badge color="red" :content="shipmentsDraft" :value="shipmentsDraft>0" overlap offset-x="15" offset-y="15">
                <v-btn class="rounded-rectangle" :to="{name:'SalesShipments'}">Shipments</v-btn>
              </v-badge>
            </div>
            <div class="arrow-up" style="top:152px; left:669.5px"/>
            <div class="vertical-line" style="top:150px; left:675px; height:25px"/>

            <!-- Returns -->
            <div style="position:absolute;top:100px;left:400px">
              <v-btn class="rounded-rectangle" :to="{name:'SalesReturns'}">Returns</v-btn>
            </div>
            <div class="horizontal-line" style="top:125px; left:550px; width:50px"/>
            <div class="arrow-left" style="top:120px; left:550px"/>
          </template>

          <!-- QBO -->
          <template v-if="connectedToAccounting && (this.permission('selling') || this.permission('buying')) && (settings.sales || settings.purchasing)">
            <div style="position:absolute;top:0px;left:440px;width:64px">
              <router-link :to="{name:'QuickBooks'}">
                <v-img src='@/assets/QB_64x64.png' style="display:inline-block;vertical-align:middle"/>
              </router-link>
            </div>
            <template v-if="this.permission('buying') && settings.purchasing">
              <div class="horizontal-line" style="top:25px; left:350px; width:90px"/>
              <div class="arrow-right" style="top:20px; left:436px"/>
            </template>

            <template v-if="this.permission('selling') && settings.sales">
              <div class="horizontal-line" style="top:25px; left:502px; width:98px"/>
              <div class="arrow-left" style="top:20px; left:502px"/>
            </template>
          </template>
        </div>

        <template v-if="(this.permission('buying') && settings.purchasing) || (this.permission('selling') && settings.sales)">
          <div class="horizontal-line" style="top:175px; left:75px; width:600px"/>
          <div class="vertical-line" style="top:175px; left:75px; height:25px"/>
          <div class="vertical-line" style="top:175px; left:275px; height:25px"/>
          <div  v-if="settings.wine" class="vertical-line" style="top:175px; left:475px; height:25px"/>
          <div class="vertical-line" style="top:175px; left:675px; height:25px"/>
        </template>

        <div style="position:absolute;" :style="{top:settings.sales||settings.purchasing?'200px':'0px'}">
          <!-- Inventory -->
          <template v-if="permission('inventory')">
            <div style="position:absolute;top:0px;left:0px">
              <v-badge color="red" :content="itemsLowInventory" :value="itemsLowInventory>0" overlap offset-x="8" offset-y="8">
                <v-btn outlined class="rectangle blue--text" :to="{name:'InventoryItems'}">Items & Services</v-btn>
              </v-badge>
            </div>

            <div style="position:absolute;top:0px;left:200px">
              <v-badge color="red" :content="spiritsLowInventory" :value="spiritsLowInventory>0" overlap offset-x="8" offset-y="8">
                <v-btn outlined class="rectangle blue--text" :to="{name:'Spirits'}">Spirits</v-btn>
              </v-badge>
            </div>

            <template v-if="settings.wine">
              <div style="position:absolute;top:0px;left:400px">
                <v-badge color="red" :content="winesLowInventory" :value="winesLowInventory>0" overlap offset-x="8" offset-y="8">
                  <v-btn outlined class="rectangle blue--text" :to="{name:'Wine'}">Wine</v-btn>
                </v-badge>
              </div>
            </template>

            <div style="position:absolute;top:0px;left:600px">
              <v-badge color="red" :content="inBondProductsLowInventory+dutyPaidProductsLowInventory" :value="inBondProductsLowInventory+dutyPaidProductsLowInventory>0" overlap offset-x="8" offset-y="8">
                <v-btn outlined class="rectangle blue--text" :to="{name:'InventoryProducts'}">Products</v-btn>
              </v-badge>
            </div>

            <template v-if="settings.casks">
              <v-btn outlined class="rectangle blue--text"
                    style="position:absolute"
                    :style="permission('production') ? (settings.bulkContainers?'top:450px;left:500px':'top:450px;left:600px') : 'top:150px;left:200px'"
                    :to="{name:'InventoryCasks'}">Casks</v-btn>
            </template>
            <template v-if="settings.bulkContainers">
              <v-btn outlined class="rectangle blue--text"
                    style="position:absolute"
                    :style="permission('production') ? (settings.casks?'top:450px;left:700px':'top:450px;left:600px') : 'top:150px;left:400px'"
                    :to="{name:'InventoryBulkContainers'}">Bulk Containers</v-btn>
            </template>
          </template>

          <!-- Production -->
          <template v-if="permission('production')">

            <!-- Mashing -->
            <template v-if="settings.mashing">
              <v-btn class="rounded-rectangle blue" :class="darkMode?'darken-3':'lighten-3'" style="position:absolute;top:150px;left:0px" :to="{name:'ProductionMashingMashBills'}">Mash Bills</v-btn>
              <div class="vertical-dotted-line" style="top:200px; left:75px"/>

              <div style="position:absolute;top:250px;left:0px">
                <v-badge color="error" :content="mashesIncomplete" :value="mashesIncomplete>0" overlap offset-x="30" offset-y="30">
                  <v-btn class="circle blue" :class="darkMode?'darken-4':'lighten-2'" :to="{name:'ProductionMashing'}">Mashing</v-btn>
                </v-badge>
              </div>
              <div class="horizontal-line" style="top:325px; left:150px"/>
              <div class="arrow-right" style="top:319px; left:194px"/>

              <div style="position:absolute;top:300px;left:200px">
                <v-badge color="red" :content="fermenterMaintenanceDue" :value="fermenterMaintenanceDue>0" overlap offset-x="8" offset-y="8">
                  <v-btn class="rectangle blue" :class="darkMode?'darken-5':'lighten-5'" :to="{name:'EquipmentFermenters'}">Fermenters</v-btn>
                </v-badge>
              </div>
              <div class="horizontal-line" style="top:325px; left:350px"/>
              <div class="arrow-right" style="top:319px; left:394px"/>
            </template>

            <!-- Distilling -->
            <template v-if="settings.distilling">
              <v-btn class="rounded-rectangle blue" :class="darkMode?'darken-3':'lighten-3'" style="position:absolute;top:150px;left:400px" :to="{name:'ProductionDistillingProcesses'}">Processes</v-btn>
              <div class="vertical-dotted-line" style="top:200px; left:475px"/>

              <div style="position:absolute;top:250px;left:400px">
                <v-badge color="error" :content="distillationsIncomplete" :value="distillationsIncomplete>0" overlap offset-x="30" offset-y="30">
                  <v-btn class="circle blue" :class="darkMode?'darken-4':'lighten-2'" :to="{name:'ProductionDistilling'}">Distilling</v-btn>
                </v-badge>
              </div>
              <div class="horizontal-line" style="top:325px; left:550px"/>
              <div class="arrow-left" style="top:319px; left:549px"/>
              <div class="arrow-right" style="top:319px; left:594px"/>
            </template>

            <!-- Bottling -->
            <div style="position:absolute;top:100px;left:600px">
              <v-badge color="error" :content="bottlingsIncomplete" :value="bottlingsIncomplete>0" overlap offset-x="30" offset-y="30">
                <v-btn class="circle blue" :class="darkMode?'darken-4':'lighten-2'" :to="{name:'ProductionBottling'}">Bottling</v-btn>
              </v-badge>
            </div>
            <div class="vertical-line" style="top:50px; left:675px"/>
            <div class="arrow-up" style="top:50px; left:670px"/>

            <!-- Tanks -->
            <div style="position:absolute;top:300px;left:600px">
              <v-badge color="red" :content="tankMaintenanceDue" :value="tankMaintenanceDue>0" overlap offset-x="8" offset-y="8">
                <v-btn class="rectangle blue" :class="darkMode?'darken-5':'lighten-5'" :to="{name:'EquipmentTanks'}">Tanks</v-btn>
              </v-badge>
            </div>

            <div class="vertical-line" style="top:250px; left:675px"/>
            <div class="arrow-up" style="top:251px; left:670px"/>
            <template v-if="settings.casks || settings.bulkContainers">
              <div class="vertical-line" style="top:350px; left:675px; height:50px"/>
              <div class="arrow-up" style="top:351px; left:670px"/>
            </template>
            <template v-if="settings.casks && settings.bulkContainers">
              <div class="horizontal-line" style="top:400px; left:575px; width:200px"/>
              <div class="vertical-line" style="top:400px; left:575px; height:50px"/>
              <div class="arrow-down" style="top:444px; left:570px"/>
              <div class="vertical-line" style="top:400px; left:775px; height:50px"/>
              <div class="arrow-down" style="top:444px; left:770px"/>
            </template>
            <template v-else-if="settings.casks || settings.bulkContainers">
              <div class="vertical-line" style="top:400px; left:675px; height:50px"/>
              <div class="arrow-down" style="top:444px; left:670px"/>
            </template>

            <!-- Blending -->
            <template v-if="settings.blending">
              <div class="horizontal-line" style="top:325px; left:750px"/>
              <div class="arrow-right" style="top:319px; left:794px"/>
              <div class="arrow-left" style="top:319px; left:750px"/>

              <v-btn class="rounded-rectangle blue" :class="darkMode?'darken-3':'lighten-3'" style="position:absolute;top:150px;left:800px" :to="{name:'ProductionBlendingFormulas'}">Formulas</v-btn>
              <div class="vertical-dotted-line" style="top:200px; left:875px"/>

              <div style="position:absolute;top:250px;left:800px">
                <v-badge color="error" :content="blendsIncomplete" :value="blendsIncomplete>0" overlap offset-x="30" offset-y="30">
                  <v-btn class="circle blue" :class="darkMode?'darken-4':'lighten-2'" :to="{name:'ProductionBlending'}">Blending</v-btn>
                </v-badge>
              </div>
            </template>
          </template>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProductionMenu',
  data() {
    return {
      hint: false,
      timesShown: 0,
      settings: {},

      purchaseOrdersRequiringApproval: 0,
      inventoryReceiptsDraft: 0,
      invoicesDraft: 0,
      shipmentsDraft: 0,
      salesOrdersOpen: 0,
      estimatesPending: 0,
      itemsLowInventory: 0,
      inBondProductsLowInventory: 0,
      dutyPaidProductsLowInventory: 0,
      winesLowInventory: 0,
      spiritsLowInventory: 0,
      mashesIncomplete: 0,
      distillationsIncomplete: 0,
      blendsIncomplete: 0,
      bottlingsIncomplete: 0,
      tankMaintenanceDue: 0,
      fermenterMaintenanceDue: 0
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    connectedToAccounting() {
      return this.company.connectedToAccounting;
    },
  },
  async created() {
    this.$store.dispatch('checkTasks');

    const po = this.permission('po.approve') && this.company.allowPO;
    const results = await this.$apiCall(`query ProductionMenu($inventory:Boolean!,$production:Boolean!,$po:Boolean!,$selling:Boolean!,$buying:Boolean!) {
                                              productionOverviewPreferences {
                                                sales,purchasing,mashing,distilling,blending,wine,casks,bulkContainers
                                              }
                                              itemsLowInventory @include(if:$inventory)
                                              inBondProductsLowInventory: productsLowInventory(bonded:true) @include(if:$inventory)
                                              dutyPaidProductsLowInventory: productsLowInventory(bonded:false) @include(if:$inventory)
                                              winesLowInventory @include(if:$inventory)
                                              spiritsLowInventory @include(if:$inventory)
                                              mashesIncomplete @include(if:$production)
                                              distillationsIncomplete @include(if:$production)
                                              blendsIncomplete @include(if:$production)
                                              bottlingsIncomplete @include(if:$production)
                                              equipmentMaintenanceDue @include(if:$production) {typeName}
                                              purchaseOrdersRequiringApproval @include(if:$po)
                                              inventoryReceiptsStatus @include(if:$buying) {draft}
                                              shipmentsDraft @include(if:$selling)
                                              invoicesDraft @include(if:$selling)
                                              salesOrdersOpen @include(if:$selling)
                                              estimatesPending @include(if:$selling)
                                            }`,
                                        {inventory:this.permission('inventory'),
                                         production:this.permission('production'),
                                         po,
                                         selling:this.permission('selling'),
                                         buying:this.permission('buying')});
    if (!results.error) {
      this.settings = results.data.productionOverviewPreferences;
      this.inventoryReceiptsDraft = results.data.inventoryReceiptsStatus.draft;
      this.purchaseOrdersRequiringApproval = po ? results.data.purchaseOrdersRequiringApproval : 0;
      this.estimatesPending = results.data.estimatesPending;
      this.salesOrdersOpen = results.data.salesOrdersOpen;
      this.shipmentsDraft = results.data.shipmentsDraft;
      this.invoicesDraft = results.data.invoicesDraft;
      this.itemsLowInventory = results.data.itemsLowInventory;
      this.inBondProductsLowInventory = results.data.inBondProductsLowInventory;
      this.dutyPaidProductsLowInventory = results.data.dutyPaidProductsLowInventory;
      this.winesLowInventory = results.data.winesLowInventory;
      this.spiritsLowInventory = results.data.spiritsLowInventory;
      this.mashesIncomplete = results.data.mashesIncomplete;
      this.distillationsIncomplete = results.data.distillationsIncomplete;
      this.blendsIncomplete = results.data.blendsIncomplete;
      this.bottlingsIncomplete = results.data.bottlingsIncomplete;
      results.data.equipmentMaintenanceDue?.forEach(e => {
        switch (e.typeName) {
          case 'Tank':
            this.tankMaintenanceDue++;
            break;
          case 'Fermenter':
            this.fermenterMaintenanceDue++;
            break;
        }
      });
    }

    // Show hint on 20th time
    if (this.permission('config.write')) {
      this.timesShown = this.$store.getters.userSettings.workflow?.timesShown ?? 0;
      if (this.timesShown < 20) {
        if (this.timesShown === 19)
          this.hint = true;
        this.timesShown++;
        const settings = this.$store.getters.userSettings;
        settings.workflow = {timesShown:this.timesShown};
        this.$store.commit('setUserSettings', settings);
      }
    }
  },
	methods: {
    async changeView() {
      await this.$apiCall(`mutation ProductionMenu($input:ProductionOverviewPreferencesInput!) {
                            productionOverviewSetPreferences(input:$input) {
                              casks
                            }
                          }`,
                          {input:this.settings});
    },
    permission(access) {
      return this.company.permissions.includes(access);
    },
    done() {
      this.hint = false;
    }
	}
}
</script>

<style scoped>
.overview-component-enter-active, .overview-component-leave-active {
  transition: opacity 1s;
}
.overview-component-enter, .overview-component-leave-to  {
  opacity: 0;
}
.v-btn {
  text-transform: none;
  font-size: 14px;
  font-weight: normal;
}
.circle {
  border-radius: 75px;
  height:150px !important;
  width:150px !important;
}
.rounded-rectangle {
	width:150px !important;
	height:50px !important;
  border-radius:25px;
}
.rectangle {
	width:150px !important;
	height:50px !important;
}
.vertical-dotted-line {
  position:absolute;
  border-right:1px dotted #aaa;
  height:50px; width:1px;
}
.vertical-line {
  position:absolute;
  border-right:1px solid #aaa;
  height:50px; width:1px;
}
.horizontal-line {
  position:absolute;
  border-top:1px solid #aaa;
  height:1px; width:50px;
}
.arrow-down {
  position:absolute;
	width: 0;
	height: 0;
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-top: 6px solid #aaa;
}
.arrow-up {
  position:absolute;
	width: 0;
	height: 0;
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-bottom: 6px solid #aaa;
}
.arrow-right {
  position:absolute;
	width: 0;
	height: 0;
	border-top: 6px solid transparent;
	border-bottom: 6px solid transparent;
	border-left: 6px solid #aaa;
}
.arrow-left {
  position:absolute;
	width: 0;
	height: 0;
	border-top: 6px solid transparent;
	border-bottom: 6px solid transparent;
	border-right:6px solid #aaa;
}
</style>
